module.exports = __webpack_public_path__ + "static/media/bipsu.logo.300w.00af7e5c.png";